import { getSelectorRoot } from 'utils/selectors';

const getBetSlip = getSelectorRoot('betSlip');

const getStakes = getBetSlip('stakes');
const getTotalStake = getBetSlip('totalStake');
const getTotalBetStake = getBetSlip('totalBetStake');
const getTotalSingleWin = getBetSlip('totalSingleWin');
const getMaxStakeLoading = getBetSlip('maxStakeLoading');
const getPredefinedStakes = getBetSlip('predefinedStakes');
export {
  getStakes,
  getTotalStake,
  getTotalBetStake,
  getTotalSingleWin,
  getMaxStakeLoading,
  getPredefinedStakes
};
